import React, { useState } from 'react';
import { Dropdown, DropdownList } from '.';
import TextInput from '../TextInput/TextInput';
import Icon, { IconType } from '../../icons/Icon';

interface DropdownSelectProps<T> {
  label?: string;
  placeholder?: string;

  items: T[];
  textBuilder: (item: T) => string;
  itemBuilder?: (item: T) => React.ReactNode;

  /** The currently selected value */
  value: T;
  onSelect: (item: T) => void;

  disabled?: boolean;

  leading?: React.ReactNode;
  tooltip?: React.ReactNode;
}

export default function DropdownSelect<T>({
  label,
  placeholder,
  items,
  textBuilder,
  itemBuilder,
  value,
  onSelect,
  leading,
  disabled = false,
  tooltip,
}: DropdownSelectProps<T>) {
  const [open, setOpen] = useState(false);

  const handleSelect = (item: T) => {
    onSelect(item);
    setOpen(false);
  };

  const input = (
    <TextInput
      tooltip={tooltip}
      label={label}
      value={textBuilder(value)}
      placeholder={placeholder}
      leading={leading}
      disabled={disabled}
      trailing={!disabled ? <Icon type={IconType.chevronDown} size={'h-5 w-5'} /> : undefined}
    />
  );

  return (
    <Dropdown
      open={open}
      setOpen={setOpen}
      dropdown={
        <DropdownList items={items} textBuilder={textBuilder} itemBuilder={itemBuilder} onClick={handleSelect} />
      }
    >
      {disabled ? (
        input
      ) : (
        <button className={`w-full text-left`} onClick={!disabled ? event => setOpen(open => !open) : undefined}>
          {input}
        </button>
      )}
    </Dropdown>
  );
}
